<template>
  <section class="project-detail">
    <div class="container">
      <!-- Lower Content -->
      <div class="lower-content">
        <div class="row">
          <div class="text-column col-lg-8 col-md-12 col-sm-12">
            <div class="upper-box">
              <div class="single-item-carousel owl-carousel owl-theme">
                <figure class="image">
                  <img
                    src="https://media.istockphoto.com/id/669775712/photo/teacher-giving-an-it-class-at-school-to-a-group-of-students.jpg?s=612x612&w=0&k=20&c=kFR__hBLIM-0PW6k4lSqAQJGo-ukLu-bbsOQk_V6edA="
                    alt=""
                  />
                </figure>
              </div>
            </div>
            <div class="col-lg-12 mobile-only">
              <aside class="sidebar-widget info-column">
                <div class="inner-column3">
                  <h3>Course Details</h3>
                  <ul class="project-info clearfix">
                    <li>
                      <div class="priceing">
                        <strong>Call for pricing</strong>
                        <!-- <strong>$00.00</strong> <sub>$500.00</sub>
                        <span class="discont">100% OFF</span> -->
                      </div>
                    </li>
                    <li>
                      <span class="icon fal fa-home-lg-alt"></span>
                      <strong>Instructor:</strong> <span>Heather T.</span>
                    </li>

                    <li>
                      <span class="icon fal fa-book"></span>
                      <strong>Lectures:</strong> <span>12</span>
                    </li>

                    <li>
                      <span class="icon fal fa-clock"></span>
                      <strong>Duration: </strong> <span>12 weeks</span>
                    </li>
                    <li>
                      <span class="icon fal fa-user"></span>
                      <strong>Capacity: </strong> <span>30 students</span>
                    </li>
                    <li>
                      <span class="icon fal fa-globe"></span>
                      <strong>Language: </strong> <span>English</span>
                    </li>
                    <li>
                      <div class="slider-btn">
                        <a href="/login" class="btn ss-btn smoth-scroll"
                          >Enroll (coming soon)
                          <i class="fal fa-long-arrow-right"></i
                        ></a>
                      </div>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
            <div class="inner-column">
              <div class="course-meta2 review style2 clearfix mb-30">
                <ul class="left">
                  <li>
                    <div class="author">
                      <div class="thumb">
                        <img
                          src="../assets/img/bg/testi_avatar.png"
                          alt="image"
                        />
                      </div>

                      <div class="text text-left">
                        <a>Heather T.</a>
                        <p>Teacher</p>
                      </div>
                    </div>
                  </li>
                  <li class="categories text-left">
                    <div class="author">
                      <div class="text">
                        <a href="#" class="course-name">Leadership</a>
                        <p>Category</p>
                      </div>
                    </div>
                  </li>
                </ul>
                <ul class="right">
                  <li class="price">Call for pricing</li>
                </ul>
              </div>

              <div style="text-align: left">
                <h3>The Lighthouse Leadership Program</h3>
                <p>During this 12-week program you will:</p>

                <ul class="list-style-one">
                  <li>
                    Enhance your self-awareness and build your Emotional
                    Intelligence to drive business results
                  </li>
                  <li>
                    Gain confidence as a leader, tackling self-doubt and
                    imposter syndrome
                  </li>
                  <li>
                    Learn how to engage your employees through trusting
                    relationships, effective communication, and coaching
                  </li>
                  <li>
                    Work effectively within your organization to influence
                    change and deliver results
                  </li>
                  <li>Champion diversity, equity, and inclusion</li>
                  <li>
                    Build your authentic leadership brand and walk away with a
                    personal leadership manifesto we call your Leadership
                    Lighthouse
                  </li>
                  <li>
                    Network, learn, and grow with like-minded women from various
                    industries
                  </li>
                </ul>

                <h3>What You Get</h3>
                <p>
                  This program offers valuable insights, personalized
                  assessments, and hands-on coaching to help you grow as a
                  leader.
                </p>

                <ul class="list-style-one">
                  <strong
                    >12 weekly 2-hour workshops OR a 3-full day workshop where
                    we cover a wide variety of topics with plenty of opportunity
                    for discussion and reflection</strong
                  ><br /><br />
                  <ul>
                    <li>
                      While we encourage everyone to participate live (we learn
                      from each other and the great conversations we have during
                      this time), we know life happens, so we record each
                      session so you can catch up if you need to miss one.
                    </li>
                    <li>
                      We keep our cohorts small enough, so everyone has an
                      opportunity to feel seen, heard, and understood - that
                      means you get to bring your experiences and challenges to
                      the group.
                    </li>
                    <li>
                      We’re big believers in leveraging the
                      <strong>wisdom in the room</strong>. We know a lot about
                      leadership but don’t have all the answers, and each of our
                      participants brings valuable insight and experience to the
                      group.
                    </li>
                    <li>
                      In these sessions, you’ll learn a lot about leadership,
                      create a community of leaders who support each other, and
                      grow as a leader.
                    </li>
                  </ul>

                  <strong>The EQi 2.0 Leadership Assessment (Value $500)</strong
                  ><br /><br />
                  <ul>
                    <li>
                      Research shows that emotional intelligence is essential
                      for navigating interpersonal relationships, making
                      balanced, effective decisions, leading through change and
                      uncertainty, building trust, and driving team engagement.
                    </li>
                    <li>What the EQ-i 2.0 Leadership Assessment Offers:</li>
                    <ul style="padding-left: 2rem">
                      <li>
                        Personalized Insights: Understand your emotional
                        intelligence strengths and areas for development.
                      </li>
                      <li>
                        Actionable Strategies: Receive targeted recommendations
                        to enhance your EQ.
                      </li>
                      <li>
                        Leadership Alignment: Learn how your EQ competencies
                        align with critical leadership skills like
                        decision-making, stress management, and empathy.
                      </li>
                      <li>
                        Team Impact: Discover how your EQ influences team
                        dynamics, communication, and collaboration.
                      </li>
                      <li>
                        Resilience Development: Equip yourself to handle
                        challenges with confidence and adaptability.
                      </li>
                    </ul>
                  </ul>

                  <strong>One-on-One Coaching (Value $500)</strong
                  ><br /><br />
                  <ul>
                    <li>
                      You’ll receive two, half-hour, one-on-one coaching
                      sessions with one of our accredited coaches.
                    </li>
                    <li>
                      You can learn a lot in a group, but you can really dig
                      into the things that are important to you and your
                      situation in these confidential sessions.
                    </li>
                    <li>
                      You will gain deeper insights into your leadership style,
                      strengths, and areas for growth.
                    </li>
                    <li>
                      Our coaches take your confidentiality seriously, so you
                      have a safe space to talk about the things that are
                      meaningful to you.
                    </li>
                    <li>We are supportive and truly want to see you thrive.</li>
                  </ul>
                </ul>
              </div>

              <h3 style="text-align: left; margin-top: 2rem">
                Meet your facilitators
              </h3>

              <div class="row course-details-teachers-main">
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="class-item mb-30">
                    <!-- class-img -->
                    <div class="class-img">
                      <div class="class-img-outer">
                        <a>
                          <img
                            src="../assets/img/team/heather.jpg"
                            alt="class image"
                        /></a>
                      </div>
                    </div>
                    <!-- class-img -->
                    <!-- schedule -->

                    <!-- schedule-end -->
                    <!-- class-content -->
                    <div class="class-content" style="text-align: left">
                      <h4 class="title"><a>Heather Thomson</a></h4>
                      <p>
                        Heather is a Certified Executive Coach, author, speaker
                        and educational leader. Before becoming a coach, she
                        worked in education for over 28 years. She obtained a
                        Masters in Educational Leadership and Administration and
                        a Masters in Counselling Psychology.
                      </p>
                      <p>
                        Heather’s passion to support new and aspiring leaders
                        has always guided her in her work with clients to help
                        them become the leaders they strive to be.
                      </p>
                      <p>
                        Heather is accredited in emotional intelligence, DISC
                        and Personality Dimensions. In addition, she is trained
                        as a Certified Positive Mental Fitness Coach and a
                        Rethinking Impostor Syndrome Coach Practitioner.
                      </p>
                      <p>
                        Heather is the chair of the Alberta chapter for Women In
                        Leadership Foundation and a mentor for new and aspiring
                        leaders in the Women In Leadership National Mentorship
                        Program.
                      </p>
                    </div>
                    <!-- class-content-end -->
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <div class="class-item mb-30">
                    <!-- class-img -->
                    <div class="class-img">
                      <div class="class-img-outer">
                        <a>
                          <img
                            src="../assets/img/team/keri.jpg"
                            alt="class image"
                        /></a>
                      </div>
                    </div>
                    <!-- class-img -->
                    <!-- schedule -->

                    <!-- schedule-end -->
                    <!-- class-content -->
                    <div class="class-content" style="text-align: left">
                      <h4 class="title"><a>Keri Schwebius </a></h4>
                      <p>
                        Keri is a Certified Executive Coach with a Master of
                        Arts in Leadership and accreditations in emotional
                        intelligence, change management, The 6 Types of Working
                        Genius and The Fearless Organization Scan. She is the
                        co-author of Mind the Gap: Navigating Your Leadership
                        Journey.
                      </p>
                      <p>
                        She has a genuine desire to create positive change in
                        the world and volunteers as founder and Chair of Women
                        in Leadership Foundation – Saskatchewan Chapter and Past
                        Chair of the Board of Directors of City Kidz Regina.
                      </p>
                      <p>
                        Keri is the owner of Ellevate Executive Coaching and
                        co-owner of LumiLead, a leadership development company.
                        She works with bright, high-achieving women and supports
                        them in their journey to becoming confident, effective
                        leaders.
                      </p>
                    </div>
                    <!-- class-content-end -->
                  </div>
                </div>
              </div>

              <h3 style="text-align: left; margin-top: 2rem">Course Content</h3>
              <p style="text-align: left">17 lectures. 1hr each</p>
              <div
                class="faq-wrap faq-wrap2 pt-30 wow fadeInUp animated"
                data-animation="fadeInUp"
                data-delay=".4s"
              >
                <div id="accordionExample" class="accordion">
                  <div class="card">
                    <div id="headingThree" class="card-header">
                      <h2 class="mb-0">
                        <button
                          class="faq-btn"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                        >
                          Topics we will cover
                          <span>17 lectures. 1hr each</span>
                        </button>
                      </h2>
                    </div>
                    <div
                      id="collapseThree"
                      class="collapse show"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="leactures" style="text-align: left">
                          <ul>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> Looking at
                                  different leadership styles and defining your
                                  personal leadership style
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> Articulating your
                                  core values to bring clarity to you and your
                                  role as a leader
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> Building your
                                  emotional intelligence to become happier and
                                  build more effective relationships
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> Defining your
                                  purpose as a leader
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> Enhancing
                                  self-awareness to understand the impact you
                                  have on others
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> Leveraging your
                                  strengths to stay motivated and advance your
                                  career
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> Your wellness and
                                  the impact it has on your ability to lead
                                  others
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> Building trusting
                                  relationships with the people you lead
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> Communicating
                                  effectively to make sure your expectations are
                                  clear and set your employees up for success
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> How to share
                                  difficult feedback in a meaningful and
                                  supportive way
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> Becoming an
                                  effective coach to help your employees learn
                                  and grow
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> Managing your work
                                  to achieve personal and organizational goals
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> Looking at
                                  organizations as dynamic systems
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> Leading change
                                  effectively and getting others on board
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> Influencing
                                  organization culture in a positive way
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> Nurturing
                                  psychological safety so your employees bring
                                  their best ideas and abilities to work
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <div class="text">
                                  <i class="fal fa-edit"></i> Our world and
                                  workplaces are continuously changing which
                                  means, to stay relevant, we must create ways
                                  to continue to learn and grow - learn about
                                  the variety of opportunities for growth and
                                  create your personal growth plan
                                </div>
                                <div class="time">
                                  <i class="fal fa-clock"></i> Duration: 1hr
                                </div>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 desktop-only">
            <aside class="sidebar-widget info-column">
              <div class="inner-column3">
                <h3>Course Details</h3>
                <ul class="project-info clearfix">
                  <li>
                    <div class="priceing">
                      <strong>Call for pricing</strong>
                      <!-- <strong>$00.00</strong> <sub>$500.00</sub>
                      <span class="discont">100% OFF</span> -->
                    </div>
                  </li>
                  <li>
                    <span class="icon fal fa-home-lg-alt"></span>
                    <strong>Instructor:</strong> <span>Heather T.</span>
                  </li>

                  <li>
                    <span class="icon fal fa-book"></span>
                    <strong>Lectures:</strong> <span>17</span>
                  </li>

                  <li>
                    <span class="icon fal fa-clock"></span>
                    <strong>Duration: </strong> <span>12 weeks</span>
                  </li>
                  <li>
                    <span class="icon fal fa-user"></span>
                    <strong>Capacity: </strong> <span>30 students</span>
                  </li>
                  <li>
                    <span class="icon fal fa-globe"></span>
                    <strong>Language: </strong> <span>English</span>
                  </li>
                  <li>
                    <span class="icon fal fa-coins"></span>
                    <strong>Financing: </strong> <span>Available</span>
                  </li>
                  <li>
                    <div class="slider-btn">
                      <a href="/login" class="btn ss-btn smoth-scroll"
                        >Enroll (coming soon)
                        <i class="fal fa-long-arrow-right"></i
                      ></a>
                    </div>
                  </li>
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      courses: [
        {
          title: "Vue.js for Beginners",
          instructor: "John Doe",
          description:
            "Learn the fundamentals of Vue.js and build amazing web applications.",
          price: 49.99,
          duration: 10,
          slug: "the-lighthouse-leadership-program",
        },
      ],
      course: null,
    };
  },
  mounted() {
    const courseName = this.$route.params.courseName;
    this.course = this.courses.find((course) => course.slug === courseName);
  },
  methods: {
    enroll() {
      alert(`You have enrolled in ${this.course.title}`);
    },
  },
};
</script>

<style scoped>
.course-details {
  max-width: 800px;
  margin: auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
}

button {
  background-color: #42b983;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: #36976f;
}

.course-details-teachers-main .class-img {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;
  height: 350px; /* Adjust height as needed */
}

.course-details-teachers-main .class-img img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures images fill the container without stretching */
  border-radius: 10px; /* Optional: adds rounded corners */
}
</style>
